(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["parallax-decor"] && !Shopify.designMode) return;
  try {
    class ParallaxDecor extends HTMLElement {
    connectedCallback() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (typeof IntersectionObserver === 'undefined') return;

      this._rafId = null;
      this._active = false;
      this._onScroll = this._onScroll.bind(this);
      this._update = this._update.bind(this);

      this._attrObserver = new MutationObserver(() => this._update());
      this._attrObserver.observe(this, {
        attributes: true,
        attributeFilter: [
          'data-anchor',
          'data-max-offset',
          'data-rise-overshoot',
          'data-anchor-mobile',
          'data-max-offset-mobile',
          'data-rise-overshoot-mobile',
        ],
      });

      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (!this._active) {
                this._active = true;
                window.addEventListener('scroll', this._onScroll, { passive: true });
                window.addEventListener('resize', this._onScroll, { passive: true });
              }
              this._update();
            } else if (this._active) {
              this._active = false;
              window.removeEventListener('scroll', this._onScroll);
              window.removeEventListener('resize', this._onScroll);
              if (this._rafId) cancelAnimationFrame(this._rafId);
              this._rafId = null;
            }
          });
        },
        { rootMargin: '50% 0%' }
      );
      this._observer.observe(this);

      // Set initial transform synchronously so elements already in view at
      // page load don't flash from 0 to their computed offset on the next frame.
      this._update();
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
      if (this._attrObserver) {
        this._attrObserver.disconnect();
        this._attrObserver = null;
      }
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
      if (this._rafId) {
        cancelAnimationFrame(this._rafId);
        this._rafId = null;
      }
    }

    _onScroll() {
      if (this._rafId) return;
      this._rafId = requestAnimationFrame(this._update);
    }

    // Reads data attributes live every call (not cached at connect time) so
    // DevTools attribute edits — or the debug panel — take effect immediately.
    _settings(isMobile) {
      const ds = this.dataset;
      const anchorAttr = (isMobile && ds.anchorMobile) || ds.anchor;
      const maxOffsetRaw = (isMobile && ds.maxOffsetMobile) || ds.maxOffset;
      const overshootRaw = (isMobile && ds.riseOvershootMobile) || ds.riseOvershoot;

      const anchor = anchorAttr === 'up' || anchorAttr === 'center' ? anchorAttr : 'rise';
      const riseOvershoot = parseFloat(overshootRaw);

      return {
        anchor,
        maxOffsetRaw,
        riseOvershoot: isFinite(riseOvershoot) ? riseOvershoot : 0.6,
      };
    }

    _resolveMaxOffset(raw, rectHeight, isMobile) {
      if (typeof raw === 'string' && raw.trim().endsWith('%')) {
        const pct = parseFloat(raw);
        if (isFinite(pct)) return { value: (pct / 100) * rectHeight, isPercent: true };
      }
      const px = parseFloat(raw);
      const value = isFinite(px) ? px : 50;
      // Legacy plain-px dampening on mobile. Percent mode and the dedicated
      // *-mobile attributes already account for breakpoint differences, so
      // this only fires for old-style fixed px values with no mobile override.
      return { value: isMobile ? value * 0.6 : value, isPercent: false };
    }

    _update() {
      this._rafId = null;
      const rect = this.getBoundingClientRect();
      if (rect.height === 0) return;
      const viewportH = window.innerHeight || document.documentElement.clientHeight;
      const viewportW = window.innerWidth || document.documentElement.clientWidth;
      const isMobile = viewportW < 768;
      const settings = this._settings(isMobile);
      const resolved = this._resolveMaxOffset(settings.maxOffsetRaw, rect.height, isMobile);
      const max = resolved.value;
      const imageCenter = rect.top + rect.height / 2;
      const viewportCenter = viewportH / 2;
      const distance = imageCenter - viewportCenter;
      const range = (viewportH + rect.height) / 2;
      let progress = distance / range;
      if (progress > 1) progress = 1;
      else if (progress < -1) progress = -1;
      let y;
      if (settings.anchor === 'up') {
        y = ((progress - 1) / 2) * max;
      } else if (settings.anchor === 'rise') {
        // t = 0 at entry, 1 at exit. Goes from +max (sunk) to −overshoot×max (above natural).
        const t = (1 - progress) / 2;
        y = max * (1 - (1 + settings.riseOvershoot) * t);
      } else {
        y = progress * max;
      }
      this.style.setProperty('--parallax-y', y.toFixed(2) + 'px');
      if (this._debugRow) this._debugRow.updateReadout(y);
    }
  }

  if (!customElements.get('parallax-decor')) {
    customElements.define('parallax-decor', ParallaxDecor);
  }

  if (!window.__parallaxDebugInit && /[?&]parallax-debug=1/.test(location.search)) {
    window.__parallaxDebugInit = true;
    document.addEventListener('DOMContentLoaded', function () {
      const els = Array.from(document.querySelectorAll('parallax-decor'));
      if (!els.length) return;

      const style = document.createElement('style');
      style.textContent =
        '#parallax-debug-panel{position:fixed;top:0;right:0;width:340px;max-height:100vh;' +
        'overflow-y:auto;background:rgba(20,20,24,0.94);color:#fff;' +
        'font:12px/1.4 -apple-system,BlinkMacSystemFont,sans-serif;z-index:2147483647;' +
        'padding:10px;box-sizing:border-box;}' +
        '#parallax-debug-panel h2{font-size:13px;margin:0 0 8px;}' +
        '#parallax-debug-panel .pdp-item{border:1px solid rgba(255,255,255,0.2);' +
        'border-radius:6px;padding:8px;margin-bottom:8px;}' +
        '#parallax-debug-panel .pdp-title{font-weight:700;margin-bottom:4px;word-break:break-word;}' +
        '#parallax-debug-panel label{display:flex;align-items:center;justify-content:space-between;' +
        'gap:6px;margin-top:4px;}' +
        '#parallax-debug-panel input[type="text"],#parallax-debug-panel select{width:110px;' +
        'font:inherit;background:#222;color:#fff;border:1px solid rgba(255,255,255,0.3);' +
        'border-radius:4px;padding:2px 4px;}' +
        '#parallax-debug-panel .pdp-y{opacity:0.7;font-size:11px;}';
      document.head.appendChild(style);

      const panel = document.createElement('div');
      panel.id = 'parallax-debug-panel';
      panel.innerHTML =
        '<h2>Parallax debug (' + els.length + ')</h2>' +
        '<div>Resize the window to switch between base and *-mobile fields below 768px.</div>';
      document.body.appendChild(panel);

      els.forEach(function (el, i) {
        const section = el.closest('[id^="shopify-section-"]');
        const label = section ? section.id.replace(/^shopify-section-/, '') : 'decor ' + i;

        const item = document.createElement('div');
        item.className = 'pdp-item';

        const title = document.createElement('div');
        title.className = 'pdp-title';
        title.textContent = label;
        item.appendChild(title);

        function makeField(labelText, attrName, isSelect) {
          const row = document.createElement('label');
          const span = document.createElement('span');
          span.textContent = labelText;
          row.appendChild(span);

          let input;
          if (isSelect) {
            input = document.createElement('select');
            ['(inherit)', 'rise', 'center', 'up'].forEach(function (opt) {
              const o = document.createElement('option');
              o.value = opt === '(inherit)' ? '' : opt;
              o.textContent = opt;
              input.appendChild(o);
            });
          } else {
            input = document.createElement('input');
            input.type = 'text';
            input.placeholder = 'e.g. 40% or 120';
          }
          input.value = el.getAttribute(attrName) || '';
          input.addEventListener('input', function () {
            if (input.value) {
              el.setAttribute(attrName, input.value);
            } else {
              el.removeAttribute(attrName);
            }
          });
          row.appendChild(input);
          item.appendChild(row);
        }

        makeField('anchor', 'data-anchor', true);
        makeField('max-offset', 'data-max-offset', false);
        makeField('rise-overshoot', 'data-rise-overshoot', false);
        makeField('anchor (mobile)', 'data-anchor-mobile', true);
        makeField('max-offset (mobile)', 'data-max-offset-mobile', false);
        makeField('rise-overshoot (mobile)', 'data-rise-overshoot-mobile', false);

        const readout = document.createElement('div');
        readout.className = 'pdp-y';
        readout.textContent = 'y: 0px';
        item.appendChild(readout);

        el._debugRow = {
          updateReadout: function (y) {
            readout.textContent = 'y: ' + y.toFixed(1) + 'px';
          },
        };

        panel.appendChild(item);
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty-stepper__btn');
    if (!btn) return;
    var stepper = btn.closest('.qty-stepper');
    if (!stepper || stepper.classList.contains('is-disabled')) return;
    var input = stepper.querySelector('.qty-stepper__input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-step'), 10) || 0;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 1;
    var maxAttr = input.getAttribute('max');
    var max = maxAttr === null ? null : parseInt(maxAttr, 10);
    var current = parseInt(input.value, 10);
    if (isNaN(current)) current = min;
    var next = current + step;
    if (next < min) next = min;
    if (max !== null && !isNaN(max) && next > max) next = max;
    if (next === current) return;
    input.value = next;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Clamp typed values to min/max on blur.
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.classList || !input.classList.contains('qty-stepper__input')) return;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 1;
    var maxAttr = input.getAttribute('max');
    var max = maxAttr === null ? null : parseInt(maxAttr, 10);
    var v = parseInt(input.value, 10);
    if (isNaN(v) || v < min) v = min;
    if (max !== null && !isNaN(max) && v > max) v = max;
    if (String(v) !== input.value) input.value = v;
  });
  } catch(e) { console.error(e); }
})();

})();
